import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import { cva } from 'class-variance-authority';
import { Loader2, X } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './button';
const modalVariants = cva('fixed left-1/2 top-1/2 w-full max-w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-2xl p-10 shadow-lg bg-[rgb(20,20,20)] text-white border border-[#343434] focus:outline-none z-1000', {
    variants: {
        variant: {
            default: '',
            success: 'text-green-900 border border-green-300 dark:text-green-100 dark:border-green-800',
            error: 'bg-[#141414] text-red-900 border border-red-300 dark:text-red-100  dark:border-red-800'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
export function Modal(param) {
    let { title, description, children, variant, open, confirmBtnText, onCancel, onConfirm, isLoading } = param;
    return /*#__PURE__*/ _jsx(Dialog.Root, {
        open: open,
        onOpenChange: onCancel,
        children: /*#__PURE__*/ _jsxs(Dialog.Portal, {
            children: [
                /*#__PURE__*/ _jsx(Dialog.Overlay, {
                    className: "fixed inset-0 bg-black/40"
                }),
                /*#__PURE__*/ _jsxs(Dialog.Content, {
                    className: cn(modalVariants({
                        variant
                    })),
                    children: [
                        /*#__PURE__*/ _jsx(Dialog.Title, {
                            className: "text-lg mb-3 font-semibold",
                            children: title
                        }),
                        description && /*#__PURE__*/ _jsx(Dialog.Description, {
                            className: "text-sm opacity-80",
                            children: description
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-4",
                            children: children
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-6 flex justify-between",
                            children: [
                                /*#__PURE__*/ _jsx(Dialog.Close, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "secondary",
                                        onClick: onCancel,
                                        disabled: isLoading,
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: onConfirm,
                                    children: isLoading ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Loader2, {
                                                className: "h-4 w-4 animate-spin"
                                            }),
                                            " Saving"
                                        ]
                                    }) : confirmBtnText !== null && confirmBtnText !== void 0 ? confirmBtnText : 'Save changes'
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Dialog.Close, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx("button", {
                                className: "absolute right-3 top-3 rounded p-1 cursor-pointer",
                                children: /*#__PURE__*/ _jsx(X, {
                                    className: "h-4 w-4"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
